import { Component } from '@angular/core';

@Component({
    selector: 'op-ancillary-service',
    templateUrl: './ancillary-service.component.html'
})
export class AncillaryServiceComponent {
}
